export default __webpack_public_path__ + "media/images/signup/rest-4f19a9ebfcfdab5b29266058e0bc1f30.png";